import { useCallback } from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from '../../components/visibility-sensor/VisibilitySensor';
import { formatNumber } from '../../utils/index';
import { connect } from 'react-redux';
import { fetchProjectCard, fetchProjectTransactionAggregates } from '../project-actions';
import LoaderProjectCard from './LoaderProjectCard';
import { getProjectFromId } from '../projects-reducer';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import RoundedImage from '../../components/RoundedImage';
import styles from './project-card.module.less';
import withRouter from '../../components/hooks/withRouter';

const ProjectFlatCard = ({ project, link, projectId, category, action, properties, dispatch, target = '' }) => {
    const handleVisible = useCallback(() => {
        dispatch(fetchProjectCard(projectId));
        dispatch(fetchProjectTransactionAggregates(projectId));
    }, [dispatch, projectId]);

    if (!project || project?.id !== projectId) {
        return (
            <VisibilitySensor onVisible={handleVisible} offset={{ bottom: 500 }}>
                <LoaderProjectCard />
            </VisibilitySensor>
        );
    }

    const receiverTitle =
        project.receiverInformation?.name && !project?.receiverInformation?.isInvited
            ? 'Pengene utbetales til'
            : 'Startet av';
    const receiverName =
        project.receiverInformation?.name && !project?.receiverInformation?.isInvited
            ? project.receiverInformation?.name
            : project.ownerInformation?.name || '';
    const backgroundLogoClass = project.img_url ? '' : styles.spleisLogo;

    return (
        <TrackEventLink
            category={category}
            action={action}
            properties={properties}
            to={link || `/project/${projectId}`}
            className={styles.container}
            target={target}
        >
            <RoundedImage
                size={''}
                className={[styles.fullImage, backgroundLogoClass].join(' ')}
                showDefault={false}
                src={project.img_url}
            />

            <div className={styles.secondaryWrapper}>
                <div className={styles.titleContainer}>
                    <h3 className={styles.title}>{project.title}</h3>
                </div>
                <div className={styles.moneyInfo}>
                    <div className={styles.collectedInfo}>
                        <div className={styles.payoutSubtitle}>Totalt innsamlet</div>
                        <div className={styles.payoutValue}>{formatNumber(project.collected_amount)} kr</div>
                    </div>
                    <div className={styles.payoutInfo}>
                        {receiverName && (
                            <>
                                <div className={styles.payoutSubtitle}>{receiverTitle}</div>
                                <div className={styles.payoutValue}>{receiverName}</div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </TrackEventLink>
    );
};

ProjectFlatCard.propTypes = {
    projectId: PropTypes.number.isRequired,
    project: PropTypes.object,
    category: PropTypes.string,
    action: PropTypes.string,
    parameters: PropTypes.object,
    link: PropTypes.string,
    target: PropTypes.string,
};

function mapStateToProps(state, props) {
    let projectId = parseInt(props.projectId, 10);
    let project = props.project;
    if (projectId) {
        project = getProjectFromId(state, projectId);
    } else if (project) {
        projectId = project.id;
    }

    if (!!state.transactions?.push && state.transactions.transactions?.[0]?.collected) {
        const latestTransaction = state.transactions.transactions[0];
        if (project && projectId === latestTransaction.project_id) {
            project.collected_amount = latestTransaction.collected;
        }
    }

    return {
        project,
        projectId,
    };
}

export default withRouter(connect(mapStateToProps)(ProjectFlatCard));
